'use client'

import SimpleSlider from '@/components/simple-slider'
import PropertyCard from '@/screens/dashboard/ui/PropertyCard'
import SimilarPropertyIsLoading from './SimilarPropertyIsLoading'
import { Property } from './SimilarProperties'

interface SimilarPropertiesDemoProps {
  data: Property[]
  similarPropertyIsLoading: boolean
}

const SimilarPropertiesDemo = ({
  data,
  similarPropertyIsLoading,
}: SimilarPropertiesDemoProps) => {
  if (similarPropertyIsLoading) {
    return <SimilarPropertyIsLoading />
  }

  if (data.length === 0) return null

  return (
    <>
      <div className='font-semibold text-[18px] leading-[150%] text-[#1E1F24] my-5'>
        Similar properties
      </div>

      <SimpleSlider
        className='w-full'
        settings={{
          dots: false,
          arrows: false,
          autoplay: true,
          slideSize: {
            base: '100%',
            sm: '50%',
            md: '33.333333%',
            lg: '25%',
          },
          slideGap: {
            base: '28px',
            sm: 'md',
            md: '28px',
          },
          emblaOptions: {
            dragFree: true,
            align: 'start',
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            loop: false,
          },
        }}
      >
        {data.map((property) => (
          <PropertyCard
            key={property.property_uid}
            className='h-full'
            property={property}
            ishome
            similarproperty
          />
        ))}
      </SimpleSlider>
    </>
  )
}

export default SimilarPropertiesDemo
